import { Navigate } from "react-router";
import { useGetPriceQuery } from "../../../apis/Price.api";
import { PrimaryPrice, Price } from "../../../types/models/Price";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const PriceScoped = () => {
    const {
        data,
    } = useGetPriceQuery(PrimaryPrice.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/prices/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default PriceScoped;
